/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_History_Type_InInputs */

const vi_product_lot_history_type_in = /** @type {(inputs: Product_Lot_History_Type_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNK`)
};

/**

* @param {Product_Lot_History_Type_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_history_type_in = /** @type {((inputs?: Product_Lot_History_Type_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_History_Type_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_history_type_in(inputs)
});